"use strict";

exports.__esModule = true;
exports.Axis = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _d3Axis = require("d3-axis");
var _d3Selection = require("d3-selection");
var _Theme = require("../../Theme");
var _whenModern = require("../../Theme/UiDesign/whenModern");
var _excluded = ["orientation", "tickCount", "scale", "label", "labelSize", "height", "width", "textColor"];
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var getAxis = function getAxis(orientation, scale) {
  switch (orientation) {
    case "LEFT":
      return (0, _d3Axis.axisLeft)(scale);
    case "RIGHT":
      return (0, _d3Axis.axisRight)(scale);
    case "TOP":
      return (0, _d3Axis.axisTop)(scale);
    case "BOTTOM":
      return (0, _d3Axis.axisBottom)(scale);
    default:
      throw new Error("Invalid axis orientation");
  }
};
var AxisSVG = _styledComponents["default"].svg.withConfig({
  displayName: "Axis__AxisSVG",
  componentId: "sc-ewqnbn-0"
})(["color:", ";overflow:visible;", ""], (0, _Theme.val)("ChartAxisTextColor"), (0, _whenModern.whenModern)((0, _styledComponents.css)(["&[data-orientation=\"TOP\"] .tick:first-of-type text,&[data-orientation=\"BOTTOM\"] .tick:first-of-type text{text-anchor:start;}&[data-orientation=\"TOP\"] .tick:last-of-type text,&[data-orientation=\"BOTTOM\"] .tick:last-of-type text{text-anchor:end;}.domain,.tick line{display:none;}.tick text{fill:", ";font-family:", ";font-size:10.5px;}"], (0, _Theme.val)("ChartAxisTextColor"), (0, _Theme.val)("ChartFontFamilyMono"))));

/**
 * Displays an axis based on a d3-compatible scale.
 */
var Axis = exports.Axis = /*#__PURE__*/function (_Component) {
  function Axis() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.registerContainer = function (container) {
      _this.container = container;
      if (container != null) {
        _this.applyAxis(container);
      }
    };
    return _this;
  }
  _inheritsLoose(Axis, _Component);
  var _proto = Axis.prototype;
  _proto.componentDidUpdate = function componentDidUpdate() {
    if (this.container != null) {
      this.applyAxis(this.container);
    }
  };
  _proto.applyAxis = function applyAxis(container) {
    var _this$props = this.props,
      width = _this$props.width,
      height = _this$props.height,
      tickValues = _this$props.tickValues,
      orientation = _this$props.orientation,
      scale = _this$props.scale,
      tickCount = _this$props.tickCount,
      tickFormat = _this$props.tickFormat,
      axisFormatter = _this$props.axisFormatter;
    var axis = getAxis(orientation, scale);
    if (typeof tickFormat === "function") {
      axis.tickFormat(tickFormat);
    }
    if (tickValues && tickValues.length !== 0) {
      return (0, _d3Selection.select)(container).call(axis.tickValues(tickValues)).call(axisFormatter ? axisFormatter : axis);
    }
    var ticks;
    if (tickCount) {
      ticks = typeof tickCount === "number" ? tickCount : tickCount({
        width: width,
        height: height
      });
    } else {
      ticks = Math.max(2, Math.floor(Math.max(height, width) / 60));
    }
    (0, _d3Selection.select)(container).call(axis.ticks(ticks)).call(axisFormatter ? axisFormatter : axis);
  };
  _proto.getAxisSize = function getAxisSize() {
    var _this$props2 = this.props,
      label = _this$props2.label,
      labelSize = _this$props2.labelSize,
      width = _this$props2.width,
      height = _this$props2.height,
      orientation = _this$props2.orientation;
    if (!label) {
      return {
        width: width,
        height: height
      };
    }
    if (orientation === "LEFT" || orientation === "RIGHT") {
      return {
        width: width - labelSize,
        height: height
      };
    }
    return {
      width: width,
      height: height - labelSize
    };
  };
  _proto.getAxisXY = function getAxisXY() {
    var _this$props3 = this.props,
      orientation = _this$props3.orientation,
      height = _this$props3.height,
      width = _this$props3.width,
      padding = _this$props3.padding;
    var x = 0;
    var y = 0;
    if (orientation === "TOP") {
      y = height - 1;
    } else if (orientation === "LEFT") {
      x = width - 1;
      y = padding;
    } else if (orientation === "RIGHT") {
      x = 1;
      y = padding;
    } else if (orientation === "BOTTOM") {
      y = 1;
    }
    return {
      x: x,
      y: y
    };
  };
  _proto.getLabelTransform = function getLabelTransform() {
    var _this$props4 = this.props,
      orientation = _this$props4.orientation,
      height = _this$props4.height,
      width = _this$props4.width,
      labelSize = _this$props4.labelSize;
    var rotate = 0;
    var x = 0;
    var y = 0;
    if (orientation === "TOP") {
      y = labelSize;
      x = width / 2;
    } else if (orientation === "LEFT") {
      x = 0 - height / 2;
      y = labelSize;
      rotate = -90;
    } else if (orientation === "RIGHT") {
      x = 0 - height / 2;
      y = width - labelSize;
      rotate = -90;
    } else if (orientation === "BOTTOM") {
      y = height - labelSize;
      x = width / 2;
    }
    return "rotate(" + rotate + "deg) translate(" + x + "px, " + y + "px)";
  };
  _proto.render = function render() {
    var _this$props5 = this.props,
      orientation = _this$props5.orientation,
      tickCount = _this$props5.tickCount,
      scale = _this$props5.scale,
      label = _this$props5.label,
      labelSize = _this$props5.labelSize,
      height = _this$props5.height,
      width = _this$props5.width,
      textColor = _this$props5.textColor,
      extra = _objectWithoutPropertiesLoose(_this$props5, _excluded);
    var _this$getAxisXY = this.getAxisXY(),
      x = _this$getAxisXY.x,
      y = _this$getAxisXY.y;
    var labelElement;
    if (label) {
      labelElement = /*#__PURE__*/_react["default"].createElement("text", {
        x: 0,
        y: 0,
        textAnchor: "middle",
        alignmentBaseline: "middle",
        style: {
          transform: this.getLabelTransform()
        },
        fontSize: labelSize,
        fill: textColor || "currentColor"
      }, label);
    }
    return /*#__PURE__*/_react["default"].createElement(AxisSVG, _extends({
      height: height,
      width: width,
      "data-orientation": orientation
    }, extra), /*#__PURE__*/_react["default"].createElement("g", {
      ref: this.registerContainer,
      style: {
        transform: "translate(" + x + "px, " + y + "px)"
      }
    }), labelElement);
  };
  return Axis;
}(_react.Component);
Axis.defaultProps = {
  orientation: "LEFT",
  padding: 0,
  labelSize: 14
};